import React, { FC } from 'react';
import { rem } from 'polished';
import styled from 'styled-components';

import { breakpoints } from 'helpers/styles/constants';

import { useProgressNavItemContext } from './ProgressNavItem';

const SubNav = styled.div<{ isActive?: boolean }>`
  display: none;
  overflow: hidden;
  max-height: ${rem(500)};
  margin-top: ${rem(20)};
  padding-bottom: ${rem(2)};
  transition: max-height 0.3s ease, margin-top 0.3s ease;

  @media ${breakpoints.smUp} {
    display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  }
`;

const ProgressSubNav: FC = ({ children }) => {
  const { isActive } = useProgressNavItemContext();

  return <SubNav isActive={isActive}>{children}</SubNav>;
};

export default ProgressSubNav;
